import { render } from "./ClanLoja.vue?vue&type=template&id=c8672b64&scoped=true"
import script from "./ClanLoja.vue?vue&type=script&lang=js"
export * from "./ClanLoja.vue?vue&type=script&lang=js"

import "./ClanLoja.vue?vue&type=style&index=0&id=c8672b64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8672b64"]])

export default __exports__